import { createSlice } from '@reduxjs/toolkit'

export const loaderSlice = createSlice({
    name: 'loader',
    initialState: { loading: false },
    reducers: {
        showLoader: (state, { payload }) => {
            state.loading = payload
        },
    },
})

// Action creators are generated for each case reducer function
export const { showLoader } = loaderSlice.actions

// Selector
export const selectLoading = (state) => state.loader.loading

export default loaderSlice.reducer